import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import Forms from '../__utils/forms';
import viewportUnits from '../__utils/viewportUnits';
import HeaderMenu from '../__header/headerMenu';
import AlertBar from '../__header/AlertBar';
import headerCart from '../__header/headerCart';
import searchClear from '../__page/searchClear';
import Cookie from '../__footer/Cookie';
import a11y from '../__utils/a11y';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		a11y.audioPlayerFix();
		Video.init();
		mirrorHover();
		smoothScroll();
		Tables.init();
		viewportUnits();
		HeaderMenu.init();
		AlertBar();
		headerCart.init();
		searchClear();
		Cookie();
	},
	loaded() {
		document.querySelector('body').classList.add('page-has-loaded');
		Forms();
		viewportUnits();
	},
	resized() {
		Tables.toggleShadow();
		viewportUnits();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
